import React, {useMemo} from "react";
import {formatMenge} from "../format.js";

const SPALTEN = 16;
const ZELLE = 18;
const ZELLE_ABSTAND = 3;
const LADEFLAECHE_X = 40;
const LADEFLAECHE_Y = 46;

/**
 * Eigenes SVG "Vom Vorschlag zum LKW" (Folie 7, Auftrag S7): die Ladefläche
 * als Raster aus Paletten-Feldern, Anzahl und Beschriftung aus den echten,
 * live geladenen Einstellungen (LKW-Kapazität, Stück je Palette) statt
 * erfundener Zahlen. Die Zahl der gezeichneten Felder ist dieselbe gerundete
 * Palettenzahl wie im Text darunter (Befund S9, Sichtprüfung 3: vorher ein
 * fest verdrahtetes 4x16-Raster, das nicht zur genannten Palettenzahl
 * passte) – beide Werte stammen aus derselben Rechnung, keine feste
 * Zeilen-/Spaltenzahl mehr.
 */
export default function LkwSchaubild({lkwKapazitaetStueck, paletteStueck}) {
    const paletten = useMemo(() => {
        if (!lkwKapazitaetStueck || !paletteStueck) {
            return null;
        }
        return lkwKapazitaetStueck / paletteStueck;
    }, [lkwKapazitaetStueck, paletteStueck]);

    const anzahlFelder = paletten ? Math.round(paletten) : SPALTEN;
    const reihen = Math.max(1, Math.ceil(anzahlFelder / SPALTEN));
    const ladeflaecheBreite = SPALTEN * (ZELLE + ZELLE_ABSTAND) + 16;
    const ladeflaecheHoehe = reihen * (ZELLE + ZELLE_ABSTAND) + 16;

    return (
        <svg
            viewBox={`0 0 620 ${LADEFLAECHE_Y + ladeflaecheHoehe + 60}`}
            role="img"
            aria-label={`Ladefläche eines LKW: ${paletten ? Math.round(paletten) : "?"} Paletten, ${formatMenge(lkwKapazitaetStueck)} Dosen Kapazität.`}
            style={{width: "100%", height: "auto", maxWidth: 620, minWidth: 480}}
        >
            {/* Führerhaus */}
            <rect x={LADEFLAECHE_X - 34} y={LADEFLAECHE_Y + 4} width={28} height={ladeflaecheHoehe - 8} rx={4} fill="#495057" />
            <circle cx={LADEFLAECHE_X - 20} cy={LADEFLAECHE_Y + ladeflaecheHoehe + 6} r={7} fill="#212529" />
            <circle cx={LADEFLAECHE_X + ladeflaecheBreite - 30} cy={LADEFLAECHE_Y + ladeflaecheHoehe + 6} r={7} fill="#212529" />
            <circle cx={LADEFLAECHE_X + ladeflaecheBreite - 10} cy={LADEFLAECHE_Y + ladeflaecheHoehe + 6} r={7} fill="#212529" />

            {/* Ladefläche als Rahmen */}
            <rect x={LADEFLAECHE_X} y={LADEFLAECHE_Y} width={ladeflaecheBreite} height={ladeflaecheHoehe} rx={4} fill="#f8f9fa" stroke="#495057" strokeWidth={2} />

            {Array.from({length: anzahlFelder}).map((_, i) => {
                const reihe = Math.floor(i / SPALTEN);
                const spalte = i % SPALTEN;
                return (
                    <rect
                        key={i}
                        x={LADEFLAECHE_X + 8 + spalte * (ZELLE + ZELLE_ABSTAND)}
                        y={LADEFLAECHE_Y + 8 + reihe * (ZELLE + ZELLE_ABSTAND)}
                        width={ZELLE}
                        height={ZELLE}
                        rx={2}
                        fill={paletten ? "#a3d900" : "#e9ecef"}
                        stroke="#ced4da"
                    />
                );
            })}

            <text x={LADEFLAECHE_X} y={LADEFLAECHE_Y + ladeflaecheHoehe + 34} fontSize={15} fontWeight={700} fill="#212529">
                {paletten ? `${formatMenge(lkwKapazitaetStueck)} Dosen ≈ ${Math.round(paletten)} Paletten je LKW` : "Kapazität wird geladen …"}
            </text>
            <text x={LADEFLAECHE_X} y={LADEFLAECHE_Y + ladeflaecheHoehe + 52} fontSize={11} fill="#6c757d">
                Cosmos liefert nur volle LKW – jedes Feld hier ist eine Palette.
            </text>
        </svg>
    );
}
